module.exports = __webpack_public_path__ + "img/czech_republick.609d927.webp";